import { SPHERE_IDS } from './spheres.js';
function rebaseDays(base, local, server) {
    const out = { ...server };
    const days = new Set([...Object.keys(base), ...Object.keys(local)]);
    for (const day of days) {
        const b = base[day];
        const l = local[day];
        if (b === l)
            continue;
        if (l === undefined)
            delete out[day];
        else
            out[day] = l;
    }
    return out;
}
const pick = (base, local, server) => (local !== base ? local : server);
function rebaseSkill(base, local, server) {
    if (!base)
        return server ? { ...server, ...local, done: { ...server.done, ...local.done }, hours: { ...server.hours, ...local.hours } } : local;
    const from = server ?? base;
    const goal = pick(base.goal, local.goal, from.goal);
    return {
        id: local.id,
        sphere: pick(base.sphere, local.sphere, from.sphere),
        name: pick(base.name, local.name, from.name),
        type: pick(base.type, local.type, from.type),
        done: rebaseDays(base.done, local.done, from.done),
        hours: rebaseDays(base.hours, local.hours, from.hours),
        ...(goal !== undefined ? { goal } : {}),
    };
}
function skillChanged(a, b) {
    return JSON.stringify(a) !== JSON.stringify(b);
}
function rebaseSkills(base, local, server) {
    const baseById = new Map(base.map((k) => [k.id, k]));
    const localById = new Map(local.map((k) => [k.id, k]));
    const serverById = new Map(server.map((k) => [k.id, k]));
    const out = [];
    for (const s of server) {
        const b = baseById.get(s.id);
        const l = localById.get(s.id);
        if (l)
            out.push(rebaseSkill(b, l, s));
        else if (!b)
            out.push(s); // появился на другом устройстве
        // удалён здесь: удаляем и там
    }
    for (const l of local) {
        if (serverById.has(l.id))
            continue;
        const b = baseById.get(l.id);
        // новый здесь — добавляем; удалённый там, но изменённый здесь — возвращаем
        if (!b || skillChanged(b, l))
            out.push(rebaseSkill(b, l, undefined));
    }
    return out;
}
function rebaseHistory(base, local, server) {
    const key = (h) => JSON.stringify(h.values);
    const b = new Map(base.map((h) => [h.date, key(h)]));
    const out = new Map(server.map((h) => [h.date, h]));
    const l = new Map(local.map((h) => [h.date, h]));
    for (const [date, entry] of l)
        if (b.get(date) !== key(entry))
            out.set(date, entry);
    for (const date of b.keys())
        if (!l.has(date))
            out.delete(date);
    return [...out.values()].sort((x, y) => (x.date < y.date ? -1 : x.date > y.date ? 1 : 0));
}
function rebaseObservations(base, local, server) {
    const baseIds = new Set(base.map((o) => o.id));
    const localIds = new Set(local.map((o) => o.id));
    const out = server.filter((o) => localIds.has(o.id) || !baseIds.has(o.id));
    const have = new Set(out.map((o) => o.id));
    for (const o of local)
        if (!baseIds.has(o.id) && !have.has(o.id))
            out.push(o);
    // свежие сверху, как их показывает наблюдатель
    return out.sort((x, y) => (x.date < y.date ? 1 : x.date > y.date ? -1 : 0));
}
export function rebaseState(base, local, server) {
    const values = { ...server.values };
    for (const id of SPHERE_IDS)
        values[id] = pick(base.values[id], local.values[id], server.values[id]);
    const names = { ...(server.sphereNames ?? {}) };
    for (const id of SPHERE_IDS) {
        const b = base.sphereNames?.[id];
        const l = local.sphereNames?.[id];
        if (b === l)
            continue;
        if (l === undefined)
            delete names[id];
        else
            names[id] = l;
    }
    return {
        ...(Object.keys(names).length ? { sphereNames: names } : {}),
        schemaVersion: server.schemaVersion,
        timezone: pick(base.timezone, local.timezone, server.timezone),
        values,
        skills: rebaseSkills(base.skills, local.skills, server.skills),
        history: rebaseHistory(base.history, local.history, server.history),
        observations: rebaseObservations(base.observations, local.observations, server.observations),
    };
}
//# sourceMappingURL=rebase.js.map